import React, { Component } from 'react';
import ApexCharts from 'apexcharts';
import ReactApexChart from "react-apexcharts";

let _today = new Date();
let _min6Month = new Date();
_min6Month.setMonth(_today.getMonth() - 6);
let _min1Month = new Date();
_min1Month.setMonth(_today.getMonth() - 1);
let _min2Month = new Date();
_min2Month.setMonth(_today.getMonth() - 2);
let _min3Month = new Date();
_min3Month.setMonth(_today.getMonth() - 3);
let _min1Weeks = new Date();
_min1Weeks.setDate(_today.getDate() - 7);
let _min2Weeks = new Date();
_min2Weeks.setDate(_today.getDate() - 14);
let _min3Weeks = new Date();
_min3Weeks.setDate(_today.getDate() - 21);

export default class ApexChart extends Component {
    constructor(props) {
      super(props);
      this.state = {
        chartId: this.props.chartId,
        series: this.props.series,
        options: {
          chart: {
            id: this.props.chartId,
            group: this.props.groupId,
            type: 'area',
            height: this.props.height || 350,
            zoom: {
              autoScaleYaxis: true
            }
          },
          annotations: {
            yaxis: this.props.yaxis,
            xaxis: this.props.xaxis
          },
          dataLabels: {
            enabled: false
          },
          markers: {
            size: 0,
            style: 'hollow',
          },
          xaxis: {
            type: 'datetime',
            min: _min1Month.getTime(),
            max: _today.getTime(),
            tickAmount: 6,
          },
          tooltip: {
            x: {
              format: 'dd MMM yyyy'
            }
          },
          yaxis: {
            labels: {
              minWidth: 40
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
        },
      
      
        selection: 'two_months',
      
      };
    }

  
    updateData(timeline) {
      this.setState({
        selection: timeline
      })
      switch (timeline) {
        case `one_month`:
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            _min1Month.getTime(),
            _today.getTime()
          )
          break
        case `three_weeks`:
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            _min3Weeks.getTime(),
            _today.getTime()
          )
          break
        case `two_weeks`:
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            _min2Weeks.getTime(),
            _today.getTime()
          )
          break
        case `one_week`:
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            _min1Weeks.getTime(),
            _today.getTime()
          )
          break
        case 'two_months':
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            _min2Month.getTime(),
            _today.getTime()
          )
          break
        case 'three_months':
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            _min3Month.getTime(),
            _today.getTime()
          )
          break
        case 'six_months':
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            _min6Month.getTime(),
            _today.getTime()
          )
          break
        case 'one_year':
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            new Date('27 Oct 2019').getTime(),
            new Date('27 Nov 2020').getTime()
          )
          break
        case 'ytd':
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            new Date('01 Oct 2019').getTime(),
            new Date('27 Nov 2020').getTime()
          )
          break
        case 'all':
          ApexCharts.exec(
            this.state.chartId,
            'zoomX',
            new Date('23 Oct 2019').getTime(),
            new Date('27 Nov 2020').getTime()
          )
          break
        default:
      }
    }
  

    render() {
      return (
        


  <div id="chart">
<div class="toolbar">
<button id={`one_month`}
    
    onClick={()=>this.updateData(`one_month`)} className={ (this.state.selection===`one_month` ? 'active' : '')}>
  1M
</button>
&nbsp;
<button id="three_weeks"
    
    onClick={()=>this.updateData('three_weeks')} className={ (this.state.selection==='three_weeks' ? 'active' : '')}>
  3S
</button>
&nbsp;
<button id="two_weeks"
    
    onClick={()=>this.updateData('two_weeks')} className={ (this.state.selection==='two_weeks' ? 'active' : '')}>
  2S
</button>
&nbsp;
<button id="one_week"
    
    onClick={()=>this.updateData('one_week')} className={ (this.state.selection==='one_week' ? 'active' : '')}>
  1S
</button>

</div>

<div id="chart-timeline">
<ReactApexChart options={this.state.options} series={this.state.series} type="area" height={this.state.options.chart.height} />
</div>
</div>
);
}
}
